import { render } from "./CentersList.vue?vue&type=template&id=20e7bd28&ts=true"
import script from "./CentersList.vue?vue&type=script&lang=ts"
export * from "./CentersList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Center/CentersList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20e7bd28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20e7bd28', __exports__)) {
    api.reload('20e7bd28', __exports__)
  }
  
  module.hot.accept("./CentersList.vue?vue&type=template&id=20e7bd28&ts=true", () => {
    api.rerender('20e7bd28', render)
  })

}


export default __exports__